module.exports = __webpack_public_path__ + "assets/pooled-37a388.svg";